<div class="aba-busca">
  <div class="bloco-busca">

    <div class="col-md-4">
      <div class="bloco-tipos-buscas">
        <a (click)="getLinkBuscaSalvas()">
          <div class="item-header">
            <span>Buscas</span>
            <h2>Salvas</h2>
          </div>
          <p>Veja suas buscas salvas e agilize a sua prospecção de obras.</p>
        </a>
      </div>

      <div class="bloco-tipos-buscas">
        <a (click)="getLinkNew(6)">
          <div class="item-header">
            <span>Buscas</span>
            <h2>Edificações</h2>
          </div>
          <p>As melhores oportunidades de busca com muitos filtros.</p>
        </a>
      </div>
    </div>

    <div class="linha"></div>

    <div class="col-md-4">
      <div class="bloco-tipos-buscas">
        <a (click)="getLinkNew(234)">
          <div class="item-header">
            <span>Buscas</span>
            <h2>Imobiliária</h2>
          </div>
          <p>As melhores oportunidades para busca imobiliária com muitos filtros.</p>
        </a>
      </div>

      <div class="bloco-tipos-buscas">
        <a (click)="getLinkNew(7)">
          <div class="item-header">
            <span>Buscas</span>
            <h2>Infraestrutura</h2>
          </div>
          <p>Filtros e buscas para encontrar as melhores oportunidades do módulo.</p>
        </a>
      </div>
    </div>

    <div class="linha"></div>

    <div class="col-md-4">
      <div class="bloco-tipos-buscas">
        <a (click)="getLinkNew(5)">
          <div class="item-header">
            <span>Buscas</span>
            <h2>Industrial</h2>
          </div>
          <p>As melhores oportunidades do módulo industrial.</p>
        </a>
      </div>
    </div>

  </div>
</div>